import React, { createContext, FC, useContext, useEffect, useState } from 'react'

import { NotificationType, UiNotificationBox } from '@/components/ui/notificationBox'

type Notify = {
  message: string
  type: NotificationType
}

type ContextType = {
  setNotify: (message: string, type?: NotificationType) => void
}

const NotificationContext = createContext<ContextType>({
  setNotify: () => {
    // donothing
  }
})

const NotificationProvider: FC = (props) => {
  const [timeoutId, setTimeoutId] = useState(null)
  const [notifies, setNotifies] = useState<Array<Notify>>([])
  const [addNotify, setAddNotify] = useState<Notify>({ message: null, type: null })

  const setNotify = (message: string, type: NotificationType) => {
    setAddNotify({ message, type })
  }

  useEffect(() => {
    const { message, type } = addNotify
    if (message) {
      clearTimeout(timeoutId)
      const id = setTimeout(() => {
        setNotifies([])
        setAddNotify({ message: null, type: null })
      }, 5000)
      setTimeoutId(id)
      const newNotifies = notifies.concat()
      newNotifies.push({ message, type })
      setNotifies(newNotifies)
    }
  }, [addNotify])

  return (
    <NotificationContext.Provider value={{ setNotify }}>
      <UiNotificationBox notifies={notifies} />
      {props.children}
    </NotificationContext.Provider>
  )
}

const useNotification = (): ContextType => useContext(NotificationContext)

export { NotificationProvider, useNotification }
